import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-clipboard-check-svg-icon',
    templateUrl: 'duotone-clipboard-check-svg-icon.component.html',
    standalone: false
})

export class DuotoneClipboardCheckSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
